import { Alert } from 'corso-admin-ui';
import { Pegasus } from 'corso-types';
import DescriptionList, { Description } from '~/components/DescriptionList';
import {
  buildDiscountDescriptions,
  discountKindLabel,
} from '~/features/settings/discountDefinitions/discountSummary';
import { useDiscountDefinitions } from '~/features/settings/hooks/useDiscountDefinitions';
import { useCurrency } from '~/hooks/useCurrency';

export default function EventRegistrationDiscountDisplay({
  params,
}: {
  params: Pegasus.EventRegistrationDiscountIncentive['params'];
}) {
  const { currencyCode } = useCurrency();
  const { data: discountDefinitions } = useDiscountDefinitions();
  const definition = discountDefinitions.find(
    (d) => d.id === params.storeDiscountDefinitionId,
  );

  if (!definition) {
    return (
      <Alert variant="warning" heading="Discount Not Found">
        The discount associated with this incentive could not be found. It may
        have been deleted.
      </Alert>
    );
  }

  const descriptions: Description[] = [
    { term: 'Discount', details: definition.title },
    ...buildDiscountDescriptions(definition, currencyCode),
  ];

  if (params.discountValidityDays) {
    descriptions.push({
      term: 'Valid for',
      details: `${params.discountValidityDays} day${params.discountValidityDays === 1 ? '' : 's'}`,
    });
  }

  if (params.discountCustomerMessage) {
    descriptions.push({
      term: 'Message',
      details: params.discountCustomerMessage,
    });
  }

  descriptions.push({
    term: 'Redirect URL',
    details: params.discountRedirectUrl,
  });
  return (
    <div className="mt-2 flex flex-col items-start gap-4">
      <p className="text-sm font-semibold text-neutral-500">
        Issue {discountKindLabel(definition.discountDefinition.parameters.kind)}{' '}
        Discount
      </p>
      <DescriptionList descriptions={descriptions} layoutType="list" />
    </div>
  );
}
